import { render, staticRenderFns } from "./ResponsesFromRecipients.vue?vue&type=template&id=7075ca2c&scoped=true&"
import script from "./ResponsesFromRecipients.vue?vue&type=script&lang=js&"
export * from "./ResponsesFromRecipients.vue?vue&type=script&lang=js&"
import style0 from "./ResponsesFromRecipients.vue?vue&type=style&index=0&id=7075ca2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7075ca2c",
  null
  
)

export default component.exports